import * as React from 'react';
import { observer } from 'mobx-react';
import { createGlobalStyle } from 'styled-components';
import { AssetStore } from './stores';

interface GlobalStylesProps {
    assetStore?: AssetStore;
    children?: any;
}

@observer
class GlobalFontStyles extends React.Component<GlobalStylesProps> {
    get StyledGlobalStyles() {
        const { assetStore } = this.props;
        if (!assetStore) {
            return null;
        }
        return createGlobalStyle`${assetStore.fontFaces}`;
    }

    render() {
        const { assetStore } = this.props;
        const StyledGlobalStyles = this.StyledGlobalStyles;
        return <StyledGlobalStyles assetStore={assetStore} />;
    }
}

export default GlobalFontStyles;



// WEBPACK FOOTER //
// ./src/GlobalFontStyles.tsx